import { cellComponents } from "@portal/BaseComponents/Table/Components/cellComponents";
import { TableWrapper } from "@portal/BaseComponents/Table/Components/style";
import { defaultColumnDefs } from "@portal/BaseComponents/Table/default";
import { Formats } from "@portal/hooks/use-formats";
import { usePTPListQuery } from "@portal/queries/ptp-query";
import { ptpFiltersAtom } from "@portal/store/Filters/ptp/ptp-filter";
import { tableAtom } from "@portal/store/table/table";
import { PTPList } from "@portal/types/entities/ptp";
import { Sorter, Table } from "@sinecycle/growcomponents";
import produce from "immer";
import { useAtom } from "jotai";
import { useColumns } from "./Columns/useColumns";

interface PTPListTableProps {
  extra: Formats;
}
function PTPListTable(props: PTPListTableProps) {
  const [tableValue, setTable] = useAtom(tableAtom);
  const [filters, setFilters] = useAtom(ptpFiltersAtom);

  const { data, isLoading } = usePTPListQuery({
    page: tableValue.currentPage,
    size: 10,
    filters: {
      ...filters.sorting,
      ...filters.filterValues,
    },
  });

  function handleSort(sortParams: Sorter) {
    setFilters((filter) => {
      return produce(filter, (draft) => {
        draft.sorting = {
          order: sortParams.sortOrder,
          sort_col: sortParams.sortCol,
        };
      });
    });
  }

  const { defaultColConfigs } = useColumns(props.extra);

  return (
    <TableWrapper style={{ paddingTop: "24px" }}>
      <Table<PTPList>
        loading={isLoading}
        gridProps={{
          rowData: data?.list,
          columnDefs: defaultColConfigs,
          defaultColDef: {
            ...defaultColumnDefs,
            autoHeight: false,
            sortable: false,
          },
          animateRows: true,
          suppressMovableColumns: true,
          components: cellComponents,

          unSortIcon: true,
          enableCellTextSelection: true,
        }}
        tableState={tableValue}
        handlePageChange={(page) => {
          setTable((value) => {
            return produce(value, (draft) => {
              draft.currentPage = page;
              return draft;
            });
          });
        }}
        sortMode={{
          type: "remote",
          onSortChange: handleSort,
        }}
        enableColumnCustom={{
          type: "header-only",
          content: {
            preserve: {
              type: "LOCAL",
              storageKey: "PTP_PORTAL",
            },
          },
        }}
      />
    </TableWrapper>
  );
}

export { PTPListTable as PTPList };
